module.exports = __webpack_public_path__ + "img/Phone.99df4fb5.svg";